import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from "primereact/inputtextarea";
import { ProgressBar } from 'primereact/progressbar';
import { Tag } from 'primereact/tag';
import { Tooltip } from 'primereact/tooltip';
import React, { useEffect, useRef, useState } from "react";
import PhoneInput from 'react-phone-number-input';
import 'react-slideshow-image/dist/styles.css';
import { _endPoints, setcustomer } from '../Helper/links';
import pattern from '../Helper/pattern';
import API from '../Helper/server/API';
import { useCustomer } from '../customers/useCustomer';
import { Password } from 'primereact/password';
import '../public/themes/saga-blue/theme.css';

function UserEdit(props) {
    // States
    const [ID_user, set_ID_user] = useState(null);
    const [name, set_name] = useState("");
    const [email, set_email] = useState("");
    const [change_password,set_change_password]=useState(false);
    const [password, set_password] = useState("");
    const [repasword, set_repasword] = useState("");
    const [phone, set_phone] = useState("");
    const [state, set_state] = useState(true);
    const [error, set_error] = useState({});
    const [loading, set_loading] = useState(false);

    // Handlers
    const handel_name = (e) => {
        set_name(e.target.value.toLowerCase());
        if (
            (pattern.name_en.test(e.target.value) === false && pattern.name_ar.test(e.target.value) === false) ||
            e.target.value === "" ||
            e.target.value.length > 200
        ) {
            document.getElementById("lname") && (document.getElementById("lname").style.color = "red");
        } else {
            document.getElementById("lname") && (document.getElementById("lname").style.color = "black");
        }
    };

    const handel_email = (e) => {
        set_email(e.target.value.toLowerCase());
        if (
            pattern.email.test(e.target.value) === false ||
            e.target.value === "" || e.target.value === null  ||
            e.target.value.length > 200
        ) {
            document.getElementById("lemail") && (document.getElementById("lemail").style.color = "red");
        } else {
            document.getElementById("lemail") && (document.getElementById("lemail").style.color = "black");
        }
    };

    const handel_password = (e) => {
        set_change_password(true);
        set_password(e.target.value);
        if (
            !e.target.value || e.target.value.length<8
         ) {
             document.getElementById("lpassword") && (document.getElementById("lpassword").style.color = "red");
         } else {
             document.getElementById("lpassword") && (document.getElementById("lpassword").style.color = "black");
         }
    };

    const handel_repasword = (e) => {
        set_repasword(e.target.value);
        if (
            e.target.value!==e.target.value
        ) {
            document.getElementById("lrepasword") && (document.getElementById("lrepasword").style.color = "red");
        } else {
            document.getElementById("lrepasword") && (document.getElementById("lrepasword").style.color = "black");
        }
    };

    const handel_phone = (e) => {
        set_phone(e.target.value);
        if (pattern.phone_number.test(e.target.value) === false || e.target.value.toString().length !== 9) {
            document.getElementById("lphone") && (document.getElementById("lphone").style.color = "red");
        } else {
            document.getElementById("lphone") && (document.getElementById("lphone").style.color = "black");
        }
    };
    const [whatsapp_number, setwhatsapp_number] = useState("");
    const handel_whatsapp_number =  (value) =>
    {
        if(value)
        {
        setwhatsapp_number(value)
        if(value.toString().length<10 || value.toString().length>15)
        {
            document.getElementById("lwhatsapp_number").style.color = 'red';
        }
        else
        {
            if(value.slice(0, 4)==='+218' && value.toString().length !== 13)
            document.getElementById("lwhatsapp_number").style.color = 'red';
            else
            document.getElementById("lwhatsapp_number").style.color = 'black';
        }
        }
    }

    const [loding_set,set_loding_set]=useState(false)

    const UpdateUser = async ()=>{

        // set_loding_set(true);
         var validtion = true
        //_______________________________________________________________________________________
        //                         Validtion
        if(!name || (pattern.name_ar.test(name) === false && pattern.name_en.test(name) === false) || name==="" || name.length>200)
        {
            validtion = false
            document.getElementById("lname").style.color = 'red';
        }
        if(!phone || pattern.phone_number.test(phone)===false || phone===""  ||  phone.toString().length!==9  )
        {
            validtion = false
            document.getElementById("lphone").style.color = 'red';
        }
        if( whatsapp_number!==null && whatsapp_number!=='' && whatsapp_number.slice(0, 4)==='+218' && whatsapp_number.toString().length !== 13)
        {
            validtion = false
            document.getElementById("lwhatsapp_number").style.color = 'red';
        }
        if(!state &&  state!==0 && state!==1)
        {
            validtion = false
            document.getElementById("lstate").style.color = 'red';
        }
        if(!email || pattern.email.test(email)===false || email===""  ||   email===null )
        {
            validtion = false
            document.getElementById("lemail").style.color = 'red';
        }
        if(!password || password==null || password===""  ||  password.toString().length<8  )
        {
            validtion = false
            document.getElementById("lpassword").style.color = 'red';
        }
        if(password!==repasword)
        {
            validtion = false
            document.getElementById("lrepasword").style.color = 'red';
        }
        if(!validtion)
        {
            props.toast.current.show({
                style:{
                    fontFamily:"Cairo",
                    fontSize:"1.1rem"
                },
                life: 3000,
                severity:'error', summary: 'خطــاء', detail: "أرجــو إدخــال بيــانات العميــل"
            });
        }
        else
        {
            const data = {
                ID_user:ID_user,
                state:state,
                name:name,
                phone:phone,
                whatsapp_number:whatsapp_number,
                email:email,
                password:password,
                change_password:change_password
            }
            const response = await API.post(_endPoints.users.update,data)
            if(response?.success)
            {
                // props?.set_users([...props.users,response?.data])
                // props?.set_users_view([...props.users,response?.data])
                props?.GetUsers();
                props?.set_show_edit(false)
                props.toast.current.show({
                    style:{
                        fontSize:"1.2rem",
                        fontFamily:"Cairo"
                    },
                    life: 3000,
                    severity:'success', summary: ' نجــاح ', detail: response?.msg
                });
            }
            else if(response?.success===0)
            {
                props.toast.current.show({
                    style:{
                        fontFamily:"Cairo",
                        fontSize:"1.2rem"
                    },
                    life: 3000,
                    severity:'error', summary: 'خطــاء', detail: response?.msg
                });
                if(response?.error==="email")
                    document.getElementById("lemail").style.color="red"
                else  if(response?.error==="phone")
                    document.getElementById("lphone").style.color="red"
            }
        }
        // set_loding_set(false);
    }
    useEffect(() =>
    {
        set_ID_user(props?.user?.ID_user)
        set_state(props?.user?.state)
        set_name(props?.user?.name)
        set_phone(props?.user?.phone)
        if(props?.user?.whatsapp_number && props?.user?.whatsapp_number!=="null")
            setwhatsapp_number("+"+props?.user?.whatsapp_number)
        set_email(props?.user?.username)
        set_password('********')
        set_repasword('********')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  return (
    <div className="ibox">
        <div className='obox-body'>
            <div className='col-md-12 mt-4'>
                <div className="row"  >
                    <div className="col-md-2  mb-4">
                        <label id="lstate" className='col-md-12'>  حــالة الحســاب
                            <i className="ti ti-note pr-1" ></i>
                        </label>
                        <Button icon={state?"pi true-icon pi-check ml-2":"pi false-icon pi-times ml-2"} label={state?"فعـــال":"متــوقف"} outlined   severity={state?"success":"danger"} size="large" className='mr-1'
                            onClick={(e)=>{
                                document.getElementById('lstate').style.color="black"
                                if(state)
                                    set_state(0)
                                else
                                    set_state(1)
                                // document.getElementById("lstate").style.color = 'black';
                            }}/>
                    </div>

                    <div className="col-md-5">
                        <label id="lname"> الأسم بالكامل *
                            <i className="ti ti-user pr-1" ></i>
                        </label>
                        < label id="msg_customer" style={{paddingRight:"50px"}}></label>
                        <InputText value={name}
                        maxLength={255} placeholder=" الاسم" className="col-md-12 " style={{fontFamily:"Cairo"}} inputStyle={{fontFamily:"Cairo"}} panelStyle={{fontFamily:"Cairo",textAlign:"right"}}
                        virtualScrollerOptions={{ itemSize: 38 }} field="name" dropdown onChange={(e) => handel_name(e)} scrollHeight="400px" />
                    </div>

                    <div className="col-md-2">
                        <label id="lphone"> رقم الهاتف *
                        <i className="fa fa-phone pr-1" ></i>
                        </label>
                        <div className="p-inputgroup flex-1">
                            <InputText value={phone} maxLength={9} placeholder="9x1234567"  style={{fontFamily:"Cairo",textAlign:"left"}}
                            onChange={(e) => handel_phone(e)} />
                            <span className="p-inputgroup-addon" dir='ltr' style={{borderRight:"0 nane",borderLeft:"1px solid #ced4da"}}>+218</span>

                        </div>
                    </div>
                    <div className="col-md-3">
                        <label id="lwhatsapp_number"> رقم واتس اب
                        <i className="fa fa-whatsapp pr-1" ></i>
                        </label>
                        <div className="input-group" dir="ltr">
                        <PhoneInput
                            country='LY'
                            showValue
                            // defaultCountry="LY"
                            placeholder="ادخل رقم واتس اب"
                            value={whatsapp_number}  maxLength={15} name="whatsapp_number" id="whatsapp_number"
                            onChange={handel_whatsapp_number}
                            className="p-inputtext p-component p-autocomplete-input p-autocomplete-dd-input p-autocomplete-input p-autocomplete-dd-input col-md-12 pr-0"
                            />
                        </div>
                    </div>
                </div>
                <hr></hr>
                <div className='row'>
                    <div className="col-md-4 mb-4">
                        <label id="lemail">البريد الإلكتروني </label>
                        <InputText
                            value={email}
                            onChange={e => handel_email(e)}
                            className="w-100"
                            placeholder="ادخل البريد الإلكتروني"
                        />
                        {error.email && <small className="text-danger">{error.email}</small>}
                    </div>
                    <div className="col-md-4 mb-4">
                        <label id="lpassword" className='col-md-12 p-0'>كلمة المرور *</label>
                        <Password
                            value={password}
                            onChange={(e) => handel_password(e)}
                            toggleMask
                            placeholder="كلــمة المــرور"
                            feedback={true}
                            className="col-md-12 p-0"
                            panelStyle={{width:"360px"}}
                            inputStyle={{ paddingRight: "0.5rem",paddingLeft: "1rem", width: "360px" }} // 455px = 28.438rem
                            mediumLabel="كلمة المرور متوسطة"  strongLabel="كلمة المرور قوية" weakLabel="كلمة المرور ضعيفة"  promptLabel="اختر كلمة مرور"
                        />
                    </div>
                    <div className="col-md-4 mb-4">
                        <label id="lrepasword">تأكيد كلمة المرور *</label>
                            <Password
                            value={repasword}
                            onChange={(e) => handel_repasword(e)}
                            toggleMask
                            placeholder="إعــآدة كلــمة المــرور"
                            feedback={false}
                            className="col-md-12 p-0"
                            panelStyle={{width:"360px"}}
                            inputStyle={{ paddingRight: "0.5rem", width: "350px" }} // 455px = 28.438rem
                            promptLabel="اختر كلمة مرور"
                        />

                    </div>


                </div>
                <div className='row' style={{paddingTop:"2rem"}}>
                    <div className="col-md-12" style={{paddingTop:"40px"}}>
                        <center>
                        <Button  label=" تعـــديل المستخـــدم " dir='rtl' raised  className="pl-4 pr-4" style={{fontFamily:"Cairo",margin:"1"}} onClick={UpdateUser} loading={loding_set}  />
                        </center>
                    </div>
                </div>
            </div>
        </div>
</div>
  )
}

export default UserEdit